import React from "react";
import { Container, Button } from "react-bootstrap";

export const FinalCTASection = () => {
  return (
    <section style={{ backgroundColor: "#2959A5" }} className="py-5 text-center text-white">
      <Container>
        <h3 className="fw-bold mb-3" style={{ fontSize: "2rem" }}>
        Success Starts with a Plan
        </h3>
        <p className="mb-4 mx-auto" style={{ maxWidth: "500px", color: "#F3F1EF" }}>
        Before applying, we work with you to develop an event wishlist and rank the likelihood of approval. We’ll also suggest alternative strategies to boost your chance of success and maximise your token usage.
        </p>
        <Button
          variant="danger"
          style={{ backgroundColor: "#EF3E6D", borderColor: "#EF3E6D" }}
          className="px-5 py-3 rounded-pill fw-semibold"
        >
          Our system even features a smart event comparison tool. If you’re accepted into two events on the same day, it will help you evaluate which one offers a better risk vs reward based on projected profitability.
        </Button>
      </Container>
    </section>
  );
};
